import { render, staticRenderFns } from "./AdmissionNumberSettings.vue?vue&type=template&id=f7ce2ed8"
import script from "./AdmissionNumberSettings.vue?vue&type=script&lang=js"
export * from "./AdmissionNumberSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports